import CryptoJS from "crypto-js";
import { config } from "../../config/index";

export const imageUrl = (url) => {
  if (!url) return "";

  if (url.startsWith("/")) return url;

  const result = url.indexOf("http");

  const imageRenderUrl =
    result === -1 ? `${config?.apiBaseUrl}/api/v1/images/${url}` : url;

  return imageRenderUrl;
};

export const mediaUrl = (url) => {
  if (!url) return "";
  const result = url.indexOf("http");
  if (result === -1) return `${config?.s3BucketURL}/${url}`;
  return url;
};

export const mergeClass = (...classes) => {
  return classes.join(" ");
};

export const getFormattedPrice = (price, currency = "$") => {
  return `${currency}${parseFloat(price)}`; //removed to fixed
};

export const handleEncrypt = (message) => {
  const encrypted = CryptoJS.AES.encrypt(message, config?.secretKey).toString();
  return encrypted;
};

export const handleDecrypt = (encryptedMessage = "") => {
  if (!encryptedMessage) return "";

  try {
    const decrypted = CryptoJS.AES.decrypt(
      encryptedMessage,
      config?.secretKey
    ).toString(CryptoJS.enc.Utf8);

    return decrypted;
  } catch (error) {
    return "";
  }
};
export const generateRandomPassword = () => {
  const length = 12;
  const charset =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~";
  let password = "";
  for (let i = 0; i < length; i++) {
    const randomChar = charset.charAt(
      Math.floor(Math.random() * charset.length)
    );
    password += randomChar;
  }
  return password;
};

export const formattedKey = (key) => {
  return key
    ?.replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str?.toUpperCase());
};
export const BaseURL = (link) => `${config?.apiBaseUrl}/api/v1/${link}`;

export const apiHeader = (token, isFormData) => {
  if (token && !isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  }
  if (token && isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };
  }
  if (!token && !isFormData) {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  if (!token && isFormData) {
    return {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
  }
};

export const getNestedObject = (obj = {}, nestedKey = "") => {
  const keys = nestedKey.split(".");
  const value = keys.reduce((acc, currKey) => acc && acc[currKey], obj);
  return value;
};

export const CreateFormData = (data) => {
  const formData = new FormData();
  for (let key in data) {
    if (Array.isArray(data[key])) {
      for (let d in data[key]) {
        if (typeof data[key][d] == "string") {
          formData.append(key, data[key][d]);
        } else if (
          data[key][d] instanceof File ||
          data[key][d] instanceof Date
        ) {
          formData.append(key, data[key][d]);
        } else {
          formData.append(key, JSON.stringify(data[key][d]));
        }
      }
    } else if (typeof data[key] == "object") {
      if (data[key] instanceof File) {
        formData.append(key, data[key]);
      } else {
        formData.append(key, JSON.stringify(data[key]));
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  return formData;
};

export const capitalizeFirstLetter = (l) =>
  l.charAt(0).toUpperCase() + l.slice(1);

export var RECORDS_LIMIT = 10;
